import Bus from "../events";
class ProductEvents {
    emit(event, payload) {
        Bus.emit(event, payload);
    }
    on(event, callback) {
        const handler = (customEvent) => {
            callback(customEvent.detail);
        };
        Bus.on(event, handler);
        return () => Bus.off(event, handler);
    }
}
export default new ProductEvents();
